import React from 'react';
import Title from '../../atoms/title/title.js';
import ChatIcon from './assets/chatIcon.js';
import VoiceIcon from './assets/voiceIcon.js';
import VideoIcon from './assets/videoIcon.js';

const ChanelButton = ({ type, offline, busy, price, newPrice, titleText, startButtonText }) => {
    let className = `mbw-channel-${type}-button`;
    if (offline) {
        className = "mbw-channel-offline-button";
    }
    if (busy) {
        className = "mbw-channel-busy-button";
    }
    const profileChannelButtonImage = () => {
        switch (type) {
            case "chat":
                return React.createElement(ChatIcon, null);
            case "voiceCall":
                return React.createElement(VoiceIcon, null);
            case "videoCall":
                return React.createElement(VideoIcon, null);
            default:
                return null;
        }
    };
    return (React.createElement("div", { className: className },
        profileChannelButtonImage(),
        React.createElement("div", { className: "mbw-channel-button-text" },
            React.createElement(Title, { fontStyle: "heading-h5", bold: true }, titleText),
            React.createElement("br", null),
            React.createElement(Title, { fontStyle: "content-medium" },
                React.createElement("span", { className: newPrice && "mbw-channel-button-old-price" }, price)),
            React.createElement("br", null),
            newPrice && React.createElement(Title, { bold: true, fontStyle: "content-medium" },
                React.createElement("span", { className: "mbw-channel-button-new-price" }, newPrice))),
        React.createElement("div", { className: "mbw-channel-button-start" },
            React.createElement(Title, { fontStyle: "content-small", bold: true }, startButtonText),
            React.createElement("svg", { width: "6", height: "14", viewBox: "0 0 6 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M1.58398 11.083L5.08398 6.99967L1.58398 2.91634", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })))));
};

export { ChanelButton as default };
//# sourceMappingURL=channel_button.js.map
